import axios from 'axios';

const api = axios.create({
  baseURL: 'https://server.9ha.top/',
});

// 请求拦截器 - 自动添加卡密
api.interceptors.request.use(config => {
  const card = localStorage.getItem('card');
  if (card) {
    if (config.data) {
      config.data.card = card;
    } else {
      config.data = { card };
    }
  }
  return config;
});

// 响应拦截器 - 错误处理
api.interceptors.response.use(
  response => response,
  error => {
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        '请求失败，请检查网络连接';
    
    // 卡密失效处理
    if (error.response?.status === 403) {
      localStorage.removeItem('card');
    }
    
    return Promise.reject(new Error(errorMessage));
  }
);

// 测试卡密接口
api.testCard = (card,type="change") => api.post('/api/testCard', { card,type });

// 用户管理相关接口
api.getClubs = () => api.get('/api/getClub');
api.getClubUsers = (club) => api.post('/api/file/getUsers', { club });
api.getUserInfo = (club, user) => api.post('/api/file/getUser', { club, user });
api.uploadImg = (club,user,img_b)=>api.post('/api/file/uploadImg',{club,user,img_b});
api.deleteUser = (club, user) => api.post('/api/file/deleteUser', { club, user });
api.setUserInfo = (club, user, data) => api.post('/api/file/setUser', { club, user, ...data });

// 社团管理相关接口
api.addClub = (data) => api.post('/api/addClub', data);
api.setClub = (data) => api.post('/api/setClub', data);
api.deleteClub = (club) => api.delete('/api/deleteClub', { data: { club } });

// JSON数据管理
api.getJson = (club)=> api.post('/api/getJson',{club});
api.findJson = (club, name) => api.post('/api/findJson', { club, name });
api.setJson = (data) => api.post('/api/setJson', data);
api.changeJson = (data) => api.post('/api/changeJson', data);
api.deleteJson = (club, name) => api.delete('/api/deleteJson', { data: { club, name } });

export default api;